import { Link } from 'react-router-dom';

export default function SubNav({ label }) {
  return (
    <div className="flex justify-between items-center px-12 py-[18px] border-b border-haze/[0.12] font-mono text-[11px] font-normal tracking-[2px] text-haze/55 relative z-[2] max-[780px]:px-5 max-[780px]:py-3.5">
      <span className="text-ice tracking-[3px]">
        MERIDIAN <span className="text-haze/[0.38] tracking-[2px]">· {label}</span>
      </span>
      <Link to="/">← BACK TO SITE</Link>
    </div>
  );
}
